import { render, staticRenderFns } from "./StTeaserOverviewArticles.vue?vue&type=template&id=211d9aee"
import script from "./StTeaserOverviewArticles.vue?vue&type=script&lang=ts"
export * from "./StTeaserOverviewArticles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports